import { UseAxiosResult } from 'axios-hooks'
import { useAxiosClient } from './configs/axios-setup'
export interface IRequestError {
  status: number
  text: string
}

/**
 * Hook to generate a SAS URL for blob upload
 * Uses the server-side API to create user delegation SAS tokens
 */
export const useGenerateBlobSasUrlUpload = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/UploadFile',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

/**
 * Hook to batch generate multiple SAS URLs for blob upload in a single request
 * Reduces HTTP overhead when uploading multiple files
 */
export const useGenerateBatchBlobSasUrlUpload = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/BatchUploadFiles',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

/**
 * Hook to generate a SAS URL for blob delete
 * Uses the server-side API to create user delegation SAS tokens
 */
export const useGenerateBlobSasUrlDelete = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/DeleteFile',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

/**
 * Hook to generate a SAS URL for blob download
 * Uses the server-side API to create user delegation SAS tokens
 */
export const useGenerateBlobSasUrlDownload = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/DownloadFile',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

/**
 * Hook to generate a SAS URL for MAV-Installer download
 * Uses the server-side API to create user delegation SAS tokens for installer files
 */
export const useGenerateInstallerSasUrl = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/DownloadFile',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}

/**
 * Hook to generate a SAS URL for MAV video streaming
 * Uses the server-side API to create user delegation SAS tokens for video files
 */
export const useGenerateVideoSasUrl = (): UseAxiosResult => {
  const [{ data, loading, error }, doFetch] = useAxiosClient(
    {
      url: '/DownloadFile',
      method: 'POST'
    },
    { manual: true, autoCancel: false, useCache: false }
  )

  return [
    { data, loading, error },
    doFetch,
    () => {
      return
    }
  ]
}
